const { __ } = wp.i18n;

export class SignUp {
  constructor() {
    
    this.formId = '#signup-newsletter';
    this.url = `${scriptsData.restUrl}wp/v2/newsletter-signup`;
    
    if (!this.formId) {
      return;
    }

    this.form = document.querySelector(this.formId);

    if (!this.form) {
      return;
    }

    this.response = this.form.querySelector('.response');
    this.onSubmit = this.onSubmit.bind(this);
    // this.onSuccess = this.onSuccess.bind(this);
    // this.onError = this.onError.bind(this);

    this.form.addEventListener('submit', this.onSubmit, false);

  }

  onSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    this.resetMessage();
    this.displayLoading();

    fetch(this.url, {
      method: 'POST',
      headers: {
        'X-WP-Nonce': scriptsData.nonce,
      },
      body: formData,
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      
      this.hideLoading();

      if (data.code === 'validation_error') {
        return this.displayMessage({
          type: 'error',
          message: data.message
        });
      }
      
      const response = JSON.parse(data);
      
      return this.displayMessage({
        message: __('Suscripción exitosa', 'bizum-website')
      });

    }).catch(error => {
      console.log(error);
    });

  }

  displayLoading() {
    this.response.classList.add('is-loading');
    this.response.innerHTML = '&nbsp;';
  }
  hideLoading() {
    this.response.classList.remove('is-loading');
    this.response.innerHTML = '';
  }
  resetMessage() {
    this.response.className = 'response';
    this.response.innerHTML = '';
  }
  displayMessage({ type = 'success', message }) {
    this.response.classList.add(type);
    this.response.innerHTML = message;
  }
   
}

